import React from "react";
import "./AudioList.css";
import house from "../sounds/house-sept15-24.wav";
import nta from "../sounds/04-11-24.wav";
import dijon from "../sounds/dijon.wav"
import dawg from "../sounds/dawg.wav"
import jazzquestionmark from"../sounds/jazzquestionmark.wav"
import WaveForm from "./Waveform";

const AudioList = () => {
  const songs = [
    { name: "13-09-24.wav", file: house },
    { name: "11-04-24.wav", file: nta },
    { name: "24-01-24.wav", file: jazzquestionmark },
    { name: "07-12-23.wav", file: dijon},
    { name: "08-05-22.wav", file: dawg},
  ];
  return (
    <table className="projects-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Waveform</th>
        </tr>
      </thead>
      <tbody>
        {songs.map((song) => (
          <tr key={song.id}>
            <td className="song-name">{song.name}</td>
            <td className="waveform-cell">
              <WaveForm file={song.file}></WaveForm>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AudioList;
